import React from 'react';
import styles from './BookingFormStepper.module.css';

export default class BookingFormStepper extends React.Component {

    constructor(props) {
        super(props);

        this.resolveStep = this.resolveStep.bind(this);
        this.resolveReferenceStype = this.resolveReferenceStep.bind(this);
    }

    resolveReferenceStep() {
        if(this.props.ref1_required=="Y" && (this.props.ref1 === null || this.props.ref1 === ""))
            return false;
        if(this.props.ref2_required=="Y" && (this.props.ref2 === null || this.props.ref2 === ""))
            return false;
        if(this.props.ref3_required=="Y" && (this.props.ref3 === null || this.props.ref3 === ""))
            return false;
        if(this.props.ref1_validate && this.props.ref1 && this.props.references.indexOf(this.props.ref1.toUpperCase()) == -1)
            return false;
        return true;
    }

    resolveStep(...fields) {
        var allGood = true;
        fields.forEach((field) => {
            allGood = allGood && (field !== null && field !== "");
        });
        return allGood;
    }

    render() {

        var accountOK = this.resolveStep(
            this.props.account,
            this.props.booked_by
            );
        var referenceOK = this.resolveReferenceStep();
        var pickupOK = this.resolveStep(
            this.props.pickup_contact,
            this.props.pickup_phone,
            this.props.pickup_company,
            this.props.pickup_address1,
            this.props.pickup_suburb
            );
        var deliveryOK = this.resolveStep(
            this.props.delivery_company,
            this.props.delivery_address1,
            this.props.delivery_suburb
            );
        var goodsOK = this.resolveStep(
            this.props.item_type,
            this.props.vehicle_type,
            this.props.quantity,
            this.props.weight
            );
        var timeOK = this.props.is_ready ? true : this.resolveStep(
            this.props.pickup_date,
            this.props.pickup_time
            );
        var serviceOK = this.resolveStep(
            this.props.service
            );

        return (
            <div styleName="styles.stepper">
                <div styleName={"styles.step" + (accountOK ? " styles.step-ok" : "")}>
                    Account
                    <div styleName="styles.step-icon"></div>
                    <span className="glyphicon glyphicon-ok"></span>
                </div>
                <div styleName="styles.step-divider"></div>
                <div styleName={"styles.step" + (referenceOK ? " styles.step-ok" : "")}>
                    References
                    <div styleName="styles.step-icon"></div>
                    <span className="glyphicon glyphicon-ok"></span>
                </div>
                <div styleName="styles.step-divider"></div>
                <div styleName={"styles.step" + (pickupOK ? " styles.step-ok" : "")}>
                    Pickup
                    <div styleName="styles.step-icon"></div>
                    <span className="glyphicon glyphicon-ok"></span></div>
                <div styleName="styles.step-divider"></div>
                <div styleName={"styles.step" + (deliveryOK ? " styles.step-ok" : "")}>
                    Delivery
                    <div styleName="styles.step-icon"></div>
                    <span className="glyphicon glyphicon-ok"></span>
                </div>
                <div styleName="styles.step-divider"></div>
                <div styleName={"styles.step" + (goodsOK ? " styles.step-ok" : "")}>
                    Goods
                    <div styleName="styles.step-icon"></div>
                    <span className="glyphicon glyphicon-ok"></span>
                </div>
                <div styleName="styles.step-divider"></div>
                <div styleName={"styles.step" + (timeOK ? " styles.step-ok" : "")}>
                    Time
                    <div styleName="styles.step-icon"></div>
                    <span className="glyphicon glyphicon-ok"></span></div>
                <div styleName="styles.step-divider"></div>
                <div styleName={"styles.step" + (serviceOK ? " styles.step-ok" : "")}>
                    Service
                    <div styleName="styles.step-icon"></div>
                    <span className="glyphicon glyphicon-ok"></span>
                </div>
            </div>
        )
    }
}